import { AHButton, AHText, Box, Circle, useTheme, AHIcon } from "arkh";
import { FormattedMessage, useIntl } from "react-intl";
import React, { useCallback } from "react";
import { ScrollView, StyleSheet, View } from "react-native";

import { useSafeAreaInsets } from "react-native-safe-area-context";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";

export function AddScreenSuccess(
  props: StoreAdminNavigationScreenProps<"AddScreenSuccess">
) {
  const onNext = useCallback(() => {
    if (props.route.params.fromStorecast) {
      props.navigation.navigateDeprecated("Dashboard", {
        dashboardId: props.route.params.fromStorecast.id,
      });
    } else {
      props.navigation.popToTop();
      props.navigation.goBack();
    }
  }, [props]);
  const intl = useIntl();
  const insets = useSafeAreaInsets();
  const theme = useTheme();
  return (
    <Box
      style={{ flex: 1 }}
      spaceHorizontal="medium"
      spaceVertical="large"
      spaceBottom="small"
      insets={{ bottom: insets.bottom }}
    >
      <ScrollView
        contentContainerStyle={{
          flex: 1,
          justifyContent: "space-between",
        }}
      >
        <View>
          <AHText
            style={{ textAlign: "left" }}
            spaceBottom="large"
            type="title-big"
          >
            <FormattedMessage
              description="StorecastAdminAddTVConfigureSuccess title"
              defaultMessage="Great Work"
            />
            {"  "}
            <AHText type="stat-number" size={40}>
              🚀
            </AHText>
          </AHText>

          <View style={styles.row}>
            <Circle color="primary" size="medium">
              <AHIcon type="check" forceSize={20} customColor={theme.lightText} />
            </Circle>
            <Box spaceHorizontal="small">
              <AHText type="title-small">
                <FormattedMessage
                  description="StorecastAdminAddTVConfigure description title"
                  defaultMessage="Ready to go!"
                />
              </AHText>
              <AHText type="body">
                <FormattedMessage
                  description="StorecastAdminAddTVConfigureSuccess"
                  defaultMessage="Your new Storecast, {screenName}, is up and
              running!"
                  values={{
                    screenName: props.route.params.screenName,
                  }}
                />
              </AHText>
            </Box>
          </View>
        </View>
      </ScrollView>
      <AHButton
        themeType="primary"
        title={intl.formatMessage({
          defaultMessage: "Continue",
          description: "StorecastAdminAddTVConfigureSuccess continue button",
        })}
        style={{ marginTop: 15 }}
        onPress={() => {
          onNext();
        }}
      />
    </Box>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingRight: 40,
    marginVertical: 25,
  },
});
